import { BaseActivityLogDataDto } from "./base-activity-log-data-dto";

// Interface for open activity log data
export interface IOpenActivityLogData {
}

// DTO for open activity log data
export class OpenActivityLogDataDto implements IOpenActivityLogData {
}

// DTO for creating an open activity log, extends the base activity log DTO
export class CreateOpenActivityLogDataDto extends BaseActivityLogDataDto implements IOpenActivityLogData {
}